import { IOptionsSelect } from "components/Inputs/interfaces/options.interface";
import LSelect from "components/Inputs/LSelect";
import { getIn, useFormikContext } from "formik";
import { useLandingPageContext } from "pages/Context/LandinPageContext";
import React from "react";
import { Col, Row } from "react-bootstrap";

export default function FormTicket() {
  const { installmentsContext, supplierDataContext} = useLandingPageContext();
  const { values, errors, setFieldValue, touched, setFieldTouched } = useFormikContext();

  const options: IOptionsSelect[] = [
    {
      label: `${supplierDataContext?.cnpj}`,
      value: 0
    },
    {
      label: `${supplierDataContext?.cpf ?? ""}`,
      value: 1
    }
  ];

  return (
    <div>
     
      <Row>
        <Col md={6} sm={12}>
          <LSelect
            label="CPF/CNPJ"
            options={options}
            placeholder="CPF/CNPJ"
            name="identification"
            required
            value={getIn(values, "identification")}
            onChange={(e) => setFieldValue("identification", Number(e.target.value))}
            onBlur={() => setFieldTouched("identification", true)}
            error={getIn(errors, "identification")}
            className="mb-1"
          />
        </Col>
        <Col md={6} sm={12}>
          <LSelect
            options={installmentsContext}
            label="Parcelamento"
            name="installmentsNumber"
            value={getIn(values, "installmentsNumber")}
            onChange={(e) => {
              setFieldValue("installmentsNumber",e.target.value ? Number(e.target.value) : "");
            }}            onBlur={() => setFieldTouched("installmentsNumber", true)}
            required
            isInvalid={!!getIn(touched, "installmentsNumber") && !!getIn(errors, "installmentsNumber")}
            error={getIn(errors, "installmentsNumber")}
          />
        </Col>
      </Row>
      <div className="d-flex flex-column gap-3 py-3" style={{ fontSize: ".875rem"}}>
        <span className="text-left">      
          Após gerar o boleto, <strong>efetue o pagamento até a data de vencimento</strong> para garantir o acesso contínuo ao sistema. Você poderá salvar o comprovante de pagamento ou acessá-lo posteriormente na página de Histórico de Pagamentos.
        </span>
        <span className="text-left">      
          A confirmação do pagamento pode levar até <strong> 48 horas úteis</strong>. Assim que for identificado, seu acesso será liberado automaticamente. Caso tenha dúvidas ou precise de suporte, entre em contato com nossa equipe.
        </span>
        <span className="text-left">      
          Compras realizadas via boleto bancário não permitem cancelamento imediato. Em caso de reembolso, entre em contato com nosso atendimento para mais informações sobre os procedimentos disponíveis.
        </span>
      </div>

    </div>
  );
}